import React, { FC, useContext } from 'react';

import { EvSwitch, EvTitle } from '@evinced-private/ui-common';

import { SchedulingSectionContext } from './context';
import { schedulingLabels } from './labels';

export const SectionHeader: FC = () => {
	const { config, updateConfig } = useContext(SchedulingSectionContext);
	const { active } = config || {};
	const { scheduleScans, scheduleScansDescription } = schedulingLabels;

	const onToggle = (value: boolean): void => {
		updateConfig({ active: value });
	};

	return (
		<div className="scheduling-section-header">
			<EvTitle
				id="scheduling-section-title"
				titleText={scheduleScans}
				MoreInfoContent={<>{scheduleScansDescription}</>}
			/>
			<span>
				<EvSwitch checked={active} onChange={onToggle} />
			</span>
		</div>
	);
};
